import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'yoda-core-components/lib/components/Button/Button';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import CartIcon from 'yoda-core-components/lib/assets/svg/CartIcon.svg';
import Utils from 'yoda-core-components/lib/helpers/Utils/Utils';
import LoaderAction from '../../actions/LoadingAction';
import { selectProduct } from '../../actions/MiniPDPAction';
import { showLazy } from '../../lazy/actions/LazyAction';
import * as styles from './QuickAddToCart.css';
import config from './QuickAddToCart.config';

const cx = classNames.bind(styles);

/**
 *  Gets the theme to use
 *  @return {[Object]} [theming classes]
 * */
const getThemeConfig = (themeConfig) => {
    const wrapper = themeConfig.wrapperClass || 'wrapper';
    const wrapperClass = cx(wrapper, 'sm12', 'md12', 'lg12', 'xl12');

    const customClassName = themeConfig.customClassNameClass || '';
    const customClassNameClass = cx('addToCartBlock', customClassName);

    const buttonCustom = themeConfig.buttonCustomClass || '';
    const buttonClass = cx('buttonStyle', buttonCustom);
    return {
        wrapperClass,
        customClassNameClass,
        buttonClass,
    };
};

export class QuickAddToCart extends Component {
    static defaultProps = {
        automationId: '',
        buttonType: 'Secondary',
        buttonText: 'Add To Cart',
        enableMiniPDP: false,
        themeConfig: {},
        skuId: '',
        ppId: '',
        url: '',
        location: '',
        actions: {},
        miniPDPTriggerEvent: null,
        /* These are props from redux store */
        enableMiniPDPFeature: false,
        onAddToCartClick: () => {},
        isAddToCartClick: false,
        iconStyle: false,
        deviceType: {
            isMobile: false,
            isTablet: false,
            isDesktop: false,
        },
    };

    static propTypes = {
        automationId: PropTypes.string,
        buttonType: PropTypes.oneOf(config.BUTTON_TYPE),
        buttonText: PropTypes.string,
        enableMiniPDP: PropTypes.bool,
        themeConfig: PropTypes.object,
        skuId: PropTypes.string,
        ppId: PropTypes.string,
        url: PropTypes.string,
        location: PropTypes.string.isRequired,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        miniPDPTriggerEvent: PropTypes.string,
        /* These are props from redux store */
        enableMiniPDPFeature: PropTypes.bool,
        onAddToCartClick: PropTypes.func,
        isAddToCartClick: PropTypes.bool,
        iconStyle: PropTypes.bool,
        deviceType: PropTypes.object,
    };

    constructor(props) {
        super();
        const { themeConfig } = props;
        this.themeConfig = getThemeConfig(themeConfig);
        this.addToCartButton = this.addToCartButton.bind(this);
        this.getIconViewBox = this.getIconViewBox.bind(this);
        this.getIconSize = this.getIconSize.bind(this);
    }

    componentDidMount() {
        const { isAddToCartClick, miniPDPTriggerEvent } = this.props;
        if (isAddToCartClick) {
            this.addToCartButton();
        }

        if (miniPDPTriggerEvent) {
            document.addEventListener(miniPDPTriggerEvent, this.addToCartButton);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.ppId !== this.props.ppId) {
            return true;
        }

        /* istanbul ignore next */
        if (nextProps.enableMiniPDPFeature !== this.props.enableMiniPDPFeature) {
            return true;
        }

        /* istanbul ignore next */
        if (nextProps.enableMiniPDP !== this.props.enableMiniPDP) {
            return true;
        }

        return false;
    }

    addToCartButton(e) {
        e && e.preventDefault();
        const eventData = get(e, 'detail', false);
        let { ppId, url, skuId } = this.props;

        if (eventData && eventData.ppId) {
            ({ ppId, url, skuId } = eventData);
        }

        const { actions, onAddToCartClick } = this.props;
        if (ppId) {
            url = Utils.getRelativeUrl(url);
            const PDPUrl = url || `/p/product/${ppId}?pTmplType=regular`;
            const selections = {
                skuId,
                ppId,
                url: PDPUrl,
            };
            actions.selectProduct(selections);
            actions.showLazy('miniPDP');
            actions.showLoader();
            onAddToCartClick(selections);
        }
    }

    getIconSize(windowWidth) {
        if (this.props.deviceType.isDesktop) {
            return windowWidth && windowWidth >= 1440 ? '38px' : '32px';
        }
        return '28px';
    }

    getIconViewBox(windowWidth) {
        if (this.props.deviceType.isDesktop) {
            return windowWidth && windowWidth >= 1440 ? '0 0 38 38' : '0 0 32 32';
        }
        return '0 0 28 28';
    }

    render() {
        const {
            automationId,
            buttonType,
            buttonText,
            enableMiniPDP,
            enableMiniPDPFeature,
            location,
            ppId,
            iconStyle,
        } = this.props;
        const windowWidth = !__SERVER__ && window.innerWidth;
        if (enableMiniPDP && enableMiniPDPFeature) {
            const uniqueId = `${location}-${ppId}`;
            return (
                <div className={this.themeConfig.wrapperClass}>
                    {/* Adding unique id for activity map region */}
                    <div className={this.themeConfig.customClassNameClass} id={uniqueId}>
                        <Button
                            size="Md"
                            buttonType={buttonType}
                            automationId={automationId}
                            // this classname is for analytics BEM methodology
                            className={this.themeConfig.buttonClass}
                            onClick={this.addToCartButton}
                        >
                            {iconStyle ? (
                                <span className={cx('btnText')}>
                                    <Icon
                                        iconType="svg"
                                        classNames={cx('icon')}
                                        viewBox={this.getIconViewBox(windowWidth)}
                                        width={this.getIconSize(windowWidth)}
                                        height={this.getIconSize(windowWidth)}
                                        automationId="filter-icon"
                                    >
                                        <CartIcon />
                                    </Icon>
                                </span>
                            ) : (
                                <span className={cx('btnText')}>{buttonText}</span>
                            )}
                        </Button>
                    </div>
                </div>
            );
        }
        return null;
    }
}

const mapStateToProps = (store) => ({
    enableMiniPDPFeature: get(store, 'context.featureFlags.enableMiniPDPFeature', false),
    deviceType: store.context ? store.context.deviceType : {},
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...LoaderAction,
            selectProduct,
            showLazy,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(QuickAddToCart);
